const MuiLink = {
  styleOverrides: {
    root: ({ theme }) => ({
      cursor: 'pointer',
      '&[disabled]': {
        color: theme.palette.action.disabled,
        pointerEvents: 'none',
      },
    }),
  },
};

export default MuiLink;
